import React from 'react';
import FredController from '../controllers/FredController';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import { AhaButton } from 'components/common/reactifyWebComponent';

const exampleOne = 'Ideas created this month';
const exampleTwo = 'Customer feedback in notes';
const exampleThree = 'Features shipped last week';
const exampleFour = 'Releases in progress';

function AccountSearchAiChatCta() {
  const controller = useController(FredController);
  const { showAIChatCTA } = controller.state;
  const setQuery = (query: string) => {
    controller.actionSelectTab(FredController.TAB_SEARCH_ACCOUNT);
    controller.actionSetQuery(query);
  };

  if (!showAIChatCTA) {
    return null;
  }

  return (
    <div
      className={
        'tw-flex tw-flex-col tw-gap-3 tw-overflow-hidden tw-p-3 tw-bg-container-light-background tw-border tw-border-primary-border tw-border-solid tw-rounded tw-mx-5 tw-mt-5 tw-flex-shrink-0'
      }
    >
      <div className='tw-flex tw-flex-col tw-gap-4'>
        <div className='tw-flex tw-flex-row tw-justify-center tw-relative'>
          <div className='tw-text-100'>{'Search or ask anything'}</div>
          <AhaButton
            kind='plain'
            size='small'
            className='tw-absolute -tw-right-[2.5px] -tw-top-[2.5px]'
            onClick={controller.actionDismissAIChatCTA}
            aria-label='Hide search suggestions'
          >
            <i className='fa-regular fa-close tw-text-300' />
          </AhaButton>
        </div>
        <div className='tw-flex tw-flex-row tw-gap-2 tw-justify-center'>
          <ExamplePill value={exampleOne} callback={setQuery} />
          <ExamplePill value={exampleTwo} callback={setQuery} />
          <ExamplePill value={exampleThree} callback={setQuery} />
          <ExamplePill value={exampleFour} callback={setQuery} />
        </div>
      </div>
    </div>
  );
}

function ExamplePill({
  value,
  callback,
}: {
  value: string;
  callback: (query: string) => void;
}) {
  return (
    <AhaButton
      className='btn btn-pill tw-text-300'
      onClick={() => callback(value)}
    >
      {value}
    </AhaButton>
  );
}

export default view(AccountSearchAiChatCta);
